/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Uploadopportunitiescsv3Inputs */

const en_coinvestments_uploadopportunitiescsv3 = /** @type {(inputs: Coinvestments_Uploadopportunitiescsv3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload Opportunities (CSV)`)
};

/**
* | output |
* | --- |
* | "Upload Opportunities (CSV)" |
*
* @param {Coinvestments_Uploadopportunitiescsv3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_uploadopportunitiescsv3 = /** @type {((inputs?: Coinvestments_Uploadopportunitiescsv3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Uploadopportunitiescsv3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_uploadopportunitiescsv3(inputs)
});
export { coinvestments_uploadopportunitiescsv3 as "coInvestments_uploadOpportunitiesCsv" }